import { useEffect } from "react";
import { siteConfig } from "@/lib/site-config";
import { useFirstInteraction } from "@/hooks/useFirstInteraction";

/**
 * LeadConnector chat widget loader. It was a render-blocking-adjacent script in
 * index.html that pulled its bundle on every page load; here it is injected only
 * after the visitor's first interaction ([[useFirstInteraction]]), so it stays
 * out of the initial load and the Lighthouse trace. A real visitor sees the chat
 * bubble a moment after arriving.
 */
const ChatWidget = () => {
  const interacted = useFirstInteraction();

  useEffect(() => {
    if (!interacted) return;
    const scriptId = "lc-chat-widget-loader";
    if (document.getElementById(scriptId)) return;
    const s = document.createElement("script");
    s.id = scriptId;
    s.src = siteConfig.widgets.chatLoaderSrc;
    s.setAttribute("data-resources-url", siteConfig.widgets.chatResourcesUrl);
    s.setAttribute("data-widget-id", siteConfig.widgets.chatWidgetId);
    s.async = true;
    document.body.appendChild(s);
  }, [interacted]);

  return null;
};

export default ChatWidget;
